<template>
  <div class="leave-wrap">
    <!-- 首选：WhatsApp 快联 -->
    <div class="wa-cta">
      <div class="wa-cta-text">
        <span class="wa-badge">{{ $t('leaveMessage.fastest') }}</span>
        <h3>{{ $t('leaveMessage.title') }}</h3>
        <p v-html="$t('leaveMessage.replyMin', { hours: contact.hours })"></p>
      </div>
      <div class="wa-cta-btns">
        <a v-for="(w, i) in contact.whatsapps" :key="i"
           :href="waLink(w.number)" target="_blank" rel="noopener" class="wa-cta-btn">
          <svg viewBox="0 0 32 32" width="22" height="22" fill="currentColor"><path d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39a.63.63 0 0 1-.315-.1c-.802-.402-1.504-.817-2.163-1.447-.545-.516-1.146-1.29-1.46-1.963a.426.426 0 0 1-.073-.215c0-.33.99-.945.99-1.49 0-.143-.73-2.09-.832-2.335-.143-.372-.214-.487-.6-.487-.187 0-.36-.043-.53-.043-.302 0-.53.115-.746.315-.688.645-1.032 1.318-1.06 2.264v.114c-.014.99.472 1.977 1.017 2.78 1.23 1.82 2.506 3.41 4.554 4.34.616.287 2.035.948 2.722.948.344 0 1.518-.43 1.518-1.39 0-.085 0-.187-.014-.271-.1-.43-.83-.66-1.218-.83-.215-.1-.43-.187-.43-.43zM16.03 28.527c-1.59 0-3.13-.43-4.483-1.246l-3.13 1.004.99-3.055a8.355 8.355 0 0 1-1.376-4.612c0-4.626 3.78-8.392 8.42-8.392 4.624 0 8.4 3.766 8.4 8.392 0 4.626-3.776 8.398-8.4 8.398zm0-18.44c-5.524 0-10.03 4.49-10.03 10.01 0 1.7.43 3.364 1.262 4.85l-1.66 5.087 5.236-1.65a10.02 10.02 0 0 0 5.192 1.42c5.524 0 10.03-4.49 10.03-10.01 0-2.673-1.046-5.18-2.94-7.07a9.916 9.916 0 0 0-7.09-2.638zm12.94 9.99c0-6.645-5.405-12.077-12.04-12.077-6.635 0-12.04 5.432-12.04 12.077 0 6.645 5.405 12.077 12.04 12.077 6.635 0 12.04-5.432 12.04-12.077z"/></svg>
          <span>{{ w.label }}<br><small>{{ w.display }}</small></span>
        </a>
      </div>
    </div>

    <!-- 分隔 -->
    <div class="divider"><span>{{ $t('leaveMessage.orEmail') }}</span></div>

    <!-- 邮件表单 -->
    <div class="message-board">
      <form class="message-form" @submit.prevent="submitMessage">
        <!-- 表单头部 -->
        <div class="form-head">
          <div class="fh-icon">
            <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="4" width="20" height="16" rx="2"/><path d="m22 7-10 5L2 7"/></svg>
          </div>
          <div class="fh-text">
            <h3>{{ $t('leaveMessage.formTitle') }}</h3>
            <p>{{ $t('leaveMessage.formSub') }}</p>
          </div>
        </div>

        <div class="form-grid">
          <div class="form-group">
            <label>{{ $t('leaveMessage.fullName') }}</label>
            <div class="input-wrap">
              <span class="input-icon">
                <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
              </span>
              <input type="text" v-model="messageForm.leaveMessageUserName" :placeholder="$t('leaveMessage.fullNamePh')" />
            </div>
          </div>
          <div class="form-group">
            <label>{{ $t('leaveMessage.phone') }}</label>
            <div class="input-wrap">
              <span class="input-icon">
                <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.36 1.9.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.91.34 1.85.57 2.81.7A2 2 0 0 1 22 16.92z"/></svg>
              </span>
              <input type="tel" v-model="messageForm.leaveMessageUserPhone" :placeholder="$t('leaveMessage.phonePh')" />
            </div>
          </div>
        </div>
        <div class="form-group">
          <label>{{ $t('leaveMessage.emailLbl') }}</label>
          <div class="input-wrap">
            <span class="input-icon">
              <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="4" width="20" height="16" rx="2"/><path d="m22 7-10 5L2 7"/></svg>
            </span>
            <input type="email" v-model="messageForm.leaveMessageUserMail" :placeholder="$t('leaveMessage.emailPh')" />
          </div>
        </div>
        <div class="form-group">
          <label>{{ $t('leaveMessage.message') }}</label>
          <div class="input-wrap input-wrap--textarea">
            <span class="input-icon input-icon--top">
              <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>
            </span>
            <textarea v-model="messageForm.leaveMessageText" :placeholder="$t('leaveMessage.messagePh')" rows="4"></textarea>
          </div>
        </div>

        <div class="form-foot">
          <div class="captcha-group">
            <img :src="captchaImageUrl" alt="Verification Code" @click="refreshCaptcha" class="captcha-img" title="Click to refresh"/>
            <span class="captcha-hint" @click="refreshCaptcha">
                <svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="23 4 23 10 17 10"/><path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"/></svg>
                refresh
            </span>
            <div class="captcha-side">
              <input type="text" class="captcha-input" v-model="messageForm.captcha" :placeholder="$t('leaveMessage.codePh')" />
            </div>
          </div>
          <button type="submit" class="submit-btn">
            <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2"><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg>
            <span>{{ $t('common.sendEmail') }}</span>
          </button>
        </div>
        <p class="form-note">
          <svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
          {{ $t('leaveMessage.privacy') }}
        </p>
        <div v-if="isLoading" class="loading-overlay">
          <div class="spinner"></div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import contact, { waLink } from "@/config/contact";
export default {
  name: "LeaveMessage",
  data() {
    return {
      captchaImageUrl: '/portal_server/captcha?' + Date.now(),
      messageForm: {
        leaveMessageUserName: '',
        leaveMessageUserPhone: '',
        leaveMessageUserMail: '',
        leaveMessageText: '',
        captcha: ''
      },
      isLoading: false
    };
  },
  created() {
    this.contact = contact;
    this.waLink = waLink;
  },
  methods: {
    refreshCaptcha() {
      this.captchaImageUrl = '/portal_server/captcha?' + Date.now();
    },
    submitMessage() {
      if (!this.messageForm.captcha) {
        this.alertMsg(this.$t('leaveMessage.errCode'));
        return;
      }
      if (!this.messageForm.leaveMessageUserName.trim() ||
          !/^\d{10,15}$/.test(this.messageForm.leaveMessageUserPhone) ||
          !/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(this.messageForm.leaveMessageUserMail) ||
          !this.messageForm.leaveMessageText.trim()) {
        this.alertMsg(this.$t('leaveMessage.errForm'));
        return;
      }
      this.isLoading = true;
      this.postRequest('/leaveMessage', this.messageForm)
        .then(resp => {
          if (resp && resp.data === true) {
            this.alertMsg(this.$t('leaveMessage.okSent'));
            this.messageForm = {
              leaveMessageUserName: '',
              leaveMessageUserPhone: '',
              leaveMessageUserMail: '',
              leaveMessageText: '',
              captcha: ''
            };
          } else {
            this.alertMsg(this.$t('leaveMessage.errCodeInvalid'));
          }
          this.refreshCaptcha();
        })
        .catch(() => this.alertMsg(this.$t('leaveMessage.errFail')))
        .finally(() => { this.isLoading = false; });
    },
    alertMsg(text) {
      try {
        this.$message && this.$message.warning(text);
      } catch (e) {
        alert(text);
      }
    }
  }
}
</script>

<style scoped>
.leave-wrap { max-width: 760px; margin: 0 auto; }

/* WhatsApp CTA */
.wa-cta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  background: linear-gradient(120deg, #25D366, #128C7E);
  border-radius: 12px;
  padding: 24px 28px;
  color: #fff;
  flex-wrap: wrap;
  box-shadow: 0 8px 22px rgba(18,140,126,0.25);
}
.wa-cta-text { flex: 1; min-width: 220px; }
.wa-badge {
  display: inline-block;
  background: rgba(255,255,255,0.25);
  font-size: 11px;
  font-weight: 700;
  padding: 3px 10px;
  border-radius: 12px;
  letter-spacing: 0.5px;
  margin-bottom: 8px;
}
.wa-cta-text h3 { margin: 0 0 5px; font-size: 20px; font-weight: 700; }
.wa-cta-text p { margin: 0; font-size: 13.5px; opacity: 0.95; line-height: 1.5; }
.wa-cta-text b { opacity: 1; }
.wa-cta-btns { display: flex; flex-direction: column; gap: 10px; }
.wa-cta-btn {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  background: #fff;
  color: #128C7E;
  text-decoration: none;
  padding: 14px 22px;
  border-radius: 8px;
  font-weight: 700;
  font-size: 15px;
  transition: transform 0.2s, box-shadow 0.2s;
  text-align: left;
  line-height: 1.2;
}
.wa-cta-btn:hover { transform: translateY(-2px); box-shadow: 0 6px 18px rgba(0,0,0,0.2); }
.wa-cta-btn small { display: block; font-size: 11px; font-weight: 500; opacity: 0.75; margin-top: 2px; }

/* Divider */
.divider {
  display: flex;
  align-items: center;
  text-align: center;
  margin: 28px 0 20px;
  color: #909399;
  font-size: 13px;
}
.divider::before, .divider::after {
  content: "";
  flex: 1;
  height: 1px;
  background: #e4e7ed;
}
.divider span { padding: 0 16px; }

/* Form */
.message-board { width: 100%; }
.message-form {
  position: relative;
  background: #fff;
  border: 1px solid #eef0f4;
  padding: 28px;
  border-radius: 14px;
  box-shadow: 0 6px 20px rgba(31,39,64,0.06);
  overflow: hidden;
}
.message-form::before {
  content: "";
  position: absolute;
  top: 0; left: 0; right: 0;
  height: 4px;
  background: linear-gradient(90deg, #ff6a00, #ff9248, #ffb76b);
}

/* 表单头部 */
.form-head {
  display: flex;
  align-items: center;
  gap: 14px;
  padding-bottom: 18px;
  margin-bottom: 20px;
  border-bottom: 1px dashed #eef0f4;
}
.fh-icon {
  width: 48px; height: 48px;
  border-radius: 12px;
  background: linear-gradient(135deg, #fff7f0, #ffe0c2);
  color: #ff6a00;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.fh-text h3 { margin: 0 0 3px; font-size: 18px; font-weight: 700; color: #1f2740; }
.fh-text p { margin: 0; font-size: 13px; color: #909399; }

.form-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; }
.form-group { margin-bottom: 16px; }
.form-group label {
  display: block;
  font-size: 12.5px;
  font-weight: 600;
  color: #4b5563;
  margin-bottom: 6px;
}
.input-wrap { position: relative; }
.input-icon {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #c0c4cc;
  display: flex;
  align-items: center;
  pointer-events: none;
  transition: color 0.18s;
}
.input-icon--top { top: 14px; transform: none; }
.input-wrap input,
.input-wrap textarea {
  width: 100%;
  padding: 11px 12px 11px 38px;
  border: 1px solid #dcdfe6;
  border-radius: 8px;
  font-size: 14px;
  font-family: inherit;
  color: #303133;
  background: #fafbfc;
  outline: none;
  transition: border-color 0.18s, box-shadow 0.18s, background 0.18s;
}
.input-wrap textarea {
  resize: vertical;
  padding-left: 38px;
}
.input-wrap input::placeholder,
.input-wrap textarea::placeholder { color: #c0c4cc; }
.input-wrap input:focus,
.input-wrap textarea:focus {
  border-color: #ff6a00;
  background: #fff;
  box-shadow: 0 0 0 3px rgba(255,106,0,0.12);
}
.input-wrap:focus-within .input-icon { color: #ff6a00; }

/* 底部：验证码 + 提交 */
.form-foot {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 16px;
  margin-top: 6px;
  padding-top: 18px;
  border-top: 1px solid #f0f0f0;
  flex-wrap: wrap;
}
.captcha-group { display: flex; align-items: center; gap: 10px; }
.captcha-img {
  height: 44px;
  border-radius: 6px;
  cursor: pointer;
  border: 1px solid #dcdfe6;
  transition: border-color 0.18s;
}
.captcha-img:hover { border-color: #ff6a00; }
.captcha-side { display: flex; flex-direction: column; gap: 4px; }
.captcha-input {
  width: 180px;
  padding: 9px 12px;
  border: 1px solid #dcdfe6;
  border-radius: 6px;
  font-size: 14px;
  outline: none;
  background: #fafbfc;
  transition: border-color 0.18s, box-shadow 0.18s, background 0.18s;
}
.captcha-input:focus { border-color: #ff6a00; background: #fff; box-shadow: 0 0 0 3px rgba(255,106,0,0.12); }
.captcha-hint {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  font-size: 11px;
  color: #909399;
  cursor: pointer;
  user-select: none;
  transition: color 0.18s;
}
.captcha-hint:hover { color: #ff6a00; }

.submit-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: linear-gradient(135deg, #ff6a00, #ff9248);
  color: #fff;
  border: none;
  padding: 13px 30px;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 6px 16px rgba(255,106,0,0.28);
  transition: transform 0.2s, box-shadow 0.2s, opacity 0.2s;
}
.submit-btn:hover { transform: translateY(-2px); box-shadow: 0 10px 22px rgba(255,106,0,0.36); }
.submit-btn:active { transform: translateY(0); }

/* 隐私提示 */
.form-note {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  margin: 16px 0 0;
  font-size: 11.5px;
  color: #b5bccb;
  text-align: center;
}
.form-note svg { color: #c0c4cc; flex-shrink: 0; }

/* Loading */
.loading-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}
.spinner {
  width: 40px; height: 40px;
  border: 4px solid rgba(255,255,255,0.3);
  border-top-color: #fff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}
@keyframes spin { to { transform: rotate(360deg); } }

/* Responsive */
@media (max-width: 640px) {
  .form-grid { grid-template-columns: 1fr; }
  .wa-cta { flex-direction: column; text-align: center; }
  .message-form { padding: 22px 18px; }
  .form-foot { flex-direction: column; align-items: stretch; }
  .captcha-group { justify-content: space-between; }
  .submit-btn { justify-content: center; }
}
@media (max-width: 420px) {
  .captcha-side { flex: 1; }
  .captcha-input { width: 100%; }
}
</style>
